import { render, staticRenderFns } from "./flow.vue?vue&type=template&id=f87cb59a&scoped=true"
import script from "./flow.vue?vue&type=script&lang=js"
export * from "./flow.vue?vue&type=script&lang=js"
import style0 from "./flow.vue?vue&type=style&index=0&id=f87cb59a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87cb59a",
  null
  
)

export default component.exports